module.exports = __webpack_public_path__ + "static/img/2.dc5e65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/Turning/2.png
// module id = cr6X
// module chunks = 13